module.exports = __webpack_public_path__ + "media/GothamPro-Bold.fa49a77f.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/GothamPro-Bold.woff
// module id = 100
// module chunks = 9